import { render, staticRenderFns } from "./DeliveryDefinition.vue?vue&type=template&id=1eb87bc7&scoped=true&"
import script from "./DeliveryDefinition.vue?vue&type=script&lang=ts&"
export * from "./DeliveryDefinition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb87bc7",
  null
  
)

export default component.exports